(function (angular) {
  "use strict";

  angular.module('myApp').component('product', {
    templateUrl: '/products/product.tpl.html',
    controller: [
      '$scope', '$http','inquiryUsService', 
      function ($scope, $http, inquiryUsService) {

        $scope.paging = {};
        $scope.filters = {};
        $scope.filters.page = 1;
        $scope.filters.size = 12;
        $scope.categoryId = categoryId;

        inquiryUsService.categories().then(function (resp) {
          $scope.categories = resp.data;
        });

        $http.get('api/products/get-finish').then(function (resp) {
          $scope.finishes = resp.data;
          console.log($scope.finishes);
        });

        $scope.load = function () {
          $scope.filters.categoryId = $scope.categoryId;
          $scope.filters.finishId = $scope.finishId;
          $http.get('api/products',
            { params: $scope.filters }).then(function (resp) {

              $scope.paging = resp.data.paging;
              $scope.list = resp.data.data;
              $("html, body").animate({ scrollTop: 0 }, "slow");
            });
        };

        $scope.load();

        $scope.goToPage = function (page) {
          $scope.filters.page = page;
          $scope.load();
        };

        // Select 2 Script
        $(".custom-selectbox").select2({
          minimumResultsForSearch: -1
        }); 

        $('[data-fancybox="gallery"]').fancybox({
          thumbs: {
            autoStart: true,
            buttons: [
              "close"
            ],
          }
        });

        $scope.categoryChange = function () {
          $scope.filters.page = 1;
          $scope.load();
        }

        $scope.finishChange = function () {
          $scope.filters.page = 1;
          $scope.load();
        }
      }
    ],
  });

}(window.angular));
